import React from 'react';
import './SectionBackground.css'
const SectionBackground = () => {
    return (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1238 955"
          fill="none"
          preserveAspectRatio="none"
          className="css-1s9az8w"
        >
          <g opacity="0.5">
            <g filter="url(#filter0_f_6099_55798)">
              <rect
                x={179}
                y={95}
                width={867}
                height={515}
                fill="url(#paint0_radial_6099_55798)"
              />
            </g>
            <g opacity="0.6" filter="url(#filter1_f_6099_55798)">
              <ellipse
                cx="810.125"
                cy="612.171"
                rx="214.425"
                ry="299.018"
                transform="rotate(88.4617 810.125 612.171)"
                fill="url(#paint1_linear_6099_55798)"
              />
            </g>
            <g opacity="0.6" filter="url(#filter2_f_6099_55798)">
              <ellipse
                cx="819.92"
                cy="561.498"
                rx="117.217"
                ry="123.817"
                transform="rotate(88.4617 819.92 561.498)"
                fill="url(#paint2_linear_6099_55798)"
              />
            </g>
            <g opacity="0.6" filter="url(#filter3_f_6099_55798)">
              <ellipse
                cx={345}
                cy={349}
                rx={234}
                ry={211}
                fill="url(#paint3_linear_6099_55798)"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_f_6099_55798"
              x={84}
              y={0}
              width={1057}
              height={705}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="47.5"
                result="effect1_foregroundBlur_6099_55798"
              />
            </filter>
            <filter
              id="filter1_f_6099_55798"
              x="383.158"
              y="269.67"
              width="853.934"
              height="685.002"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation={64}
                result="effect1_foregroundBlur_6099_55798"
              />
            </filter>
            <filter
              id="filter2_f_6099_55798"
              x="558.106"
              y="306.276"
              width="523.627"
              height="510.445"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation={69}
                result="effect1_foregroundBlur_6099_55798"
              />
            </filter>
            <filter
              id="filter3_f_6099_55798"
              x="0.776733"
              y="27.7767"
              width="688.447"
              height="642.447"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="55.1116"
                result="effect1_foregroundBlur_6099_55798"
              />
            </filter>
            <radialGradient
              id="paint0_radial_6099_55798"
              cx={0}
              cy={0}
              r={1}
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(817.5 404.565) rotate(-157.859) scale(596.485 392.541)"
            >
              <stop offset="0.161517" stopColor="#491362" stopOpacity="0.73" />
              <stop offset={1} stopColor="#222143" stopOpacity={0} />
            </radialGradient>
            <linearGradient
              id="paint1_linear_6099_55798"
              x1="874.453"
              y1="447.881"
              x2="691.161"
              y2="858.056"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#22D6FE" stopOpacity="0.17" />
              <stop offset={1} stopColor="#FF39EB" stopOpacity="0.21" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_6099_55798"
              x1="901.868"
              y1="490.092"
              x2="697.606"
              y2="755.115"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#00B2FF" stopOpacity="0.79" />
              <stop offset="0.831949" stopColor="#CC00FF" stopOpacity="0.71" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_6099_55798"
              x1={915}
              y1={319}
              x2="-13.7188"
              y2="194.504"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FB29FF" stopOpacity="0.12" />
              <stop offset={1} stopColor="#3400C9" stopOpacity={0} />
            </linearGradient>
          </defs>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 11 11"
          fill="none"
          className="css-1wdcad0"
        >
          <path d="M-4.76837e-07 1H10V11" stroke="#5A5C74" strokeWidth={2} />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 11 11"
          fill="none"
          className="css-1r2xpch"
        >
          <path d="M-4.76837e-07 1H10V11" stroke="#5A5C74" strokeWidth={2} />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 11 11"
          fill="none"
          className="css-bg410c"
        >
          <path d="M-4.76837e-07 1H10V11" stroke="#5A5C74" strokeWidth={2} />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 11 11"
          fill="none"
          className="css-tpqbpo"
        >
          <path d="M-4.76837e-07 1H10V11" stroke="#5A5C74" strokeWidth={2} />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 11 11"
          fill="none"
          className="css-zfyvl1"
        >
          <path d="M-4.76837e-07 1H10V11" stroke="#5A5C74" strokeWidth={2} />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 11 11"
          fill="none"
          className="css-f67my7"
        >
          <path d="M-4.76837e-07 1H10V11" stroke="#5A5C74" strokeWidth={2} />
        </svg>
        <svg
          className="governance-landing-explore-intro-union-rect"
          width={16}
          height={16}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 9L7 16H9V9H16V7H9V0H7L7 7H0V9H7Z"
            fill="#3B3D59"
          />
        </svg>
      </>
    );
}

export default SectionBackground;